import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.35 2.35A7.95 7.95 0 0 1 8.83.04c3.67.37 6.69 3.35 7.1 7.02C16.48 11.91 12.73 16 8 16a7.98 7.98 0 0 1-7.21-4.56c-.32-.67.16-1.44.9-1.44.37 0 .72.2.88.53a5.994 5.994 0 0 0 6.8 3.31c2.22-.49 4.01-2.3 4.48-4.52A6.002 6.002 0 0 0 8 2c-1.66 0-3.14.69-4.22 1.78l1.51 1.51c.63.63.19 1.71-.7 1.71H1c-.55 0-1-.45-1-1V2.41c0-.89 1.08-1.34 1.71-.71z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgReset;
